import * as ActionTypes from '../actions'



const consultation = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.OPEN_CONSULTATION:
			return action.consultation
		case ActionTypes.CLOSE_CONSULTATION:
			return null
		case ActionTypes.OPEN_PATIENT_RECORD:
			return state && state.patient !== action.patient.id ? null : state
		case ActionTypes.CLOSE_PATIENT_RECORD:
			return null
		default:
			return state
	}
}

export default consultation


// WEBPACK FOOTER //
// ./src/reducers/consultation.js